<template>
  <section>
    <top-menu/>

    <modal-default @modal-closed="{}" modal-title="Preencha os dados do pedido" modal-id="modalOrder">
      <input-text col="12" type="text" :is-required="true" placeholder="" label="Nome do destinatário:"
                  @contentText="value => dataOrder.orderAddressee = value"/>
      <input-text col="6" type="number" :is-required="true" placeholder="" label="Quantidade de cartões:"
                  :input-error="!!(dataOrder.quantity && dataOrder.quantity < 0)"
                  :font-error="true"

                  error-validate="Deve ser maior que zero"
                  @contentText="value => dataOrder.quantity = value"/>
      <input-text col="6" type="number" :is-required="true" placeholder="" label="CEP:"
                  @contentText="value => cep = value"/>
      <input-text col="12" type="text" :is-required="true" :value-default="dataOrder.street"
                  :placeholder="dataOrder.street" label="Rua:"
                  @contentText="value => dataOrder.street = value"/>
      <input-text col="6" type="number" :is-required="true" placeholder="" label="Número:"
                  @contentText="value => dataOrder.number = value"/>
      <input-text col="6" type="text" placeholder="" label="Complemento:"
                  @contentText="value => dataOrder.complement = value"/>
      <input-text col="12" type="text" :is-required="true" :value-default="dataOrder.neighborhood"
                  :placeholder="dataOrder.neighborhood" label="Bairro:"
                  @contentText="value => dataOrder.neighborhood = value"/>
      <input-text col="6" type="text" :is-required="true" :value-default="dataOrder.city" :placeholder="dataOrder.city"
                  label="Cidade:"
                  @contentText="value => dataOrder.city = value"/>
      <input-text col="6" type="text" :is-required="true" :value-default="dataOrder.administrativeAreaCode"
                  :placeholder="dataOrder.administrativeAreaCode" label="Estado:"
                  @contentText="value => dataOrder.administrativeAreaCode = value"/>
      <input-text col="6" type="text" :is-required="true" :value-default="dataOrder.countryCode"
                  :placeholder="dataOrder.countryCode" label="Pais:"
                  @contentText="value => {}"/>

      <div v-if="formIsNotValid" class="col-md-12 error-message">Preencha os campos obrigatórios.</div>
      <btn-custom label="Criar pedido" col="12" which-side="right"
                  have-loading="true" :loading="false"
                  :disabled="!!(dataOrder.quantity && dataOrder.quantity < 0)"
                  @emit-click="createOrder()"/>
    </modal-default>

    <section>
      <div class="page-content">
        <div class="container-fluid">
          <full-loading v-if="loadingBenefits"/>

          <div v-else class="row first__row">
            <!-- CARD ORDER -->
            <div class="col-md-6 card">
              <div class="col-md-12 card__content">
                <div class="card__content__header">
                <span class="card__content__header--title">
                  Pedidos de Cartão
                </span>
                  <button @click="openModalCreate()" class="btnCreate">Criar pedido</button>
                </div>
                <div class="card__content__body">
                  <table class="card__content__body--table">
                    <thead>
                    <tr>
                      <th>ID</th>
                      <th>Quantidade</th>
                      <th>Atualizado em</th>
                      <th>Status</th>
                      <th>Ações</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(value, index) in cardOrderList.content">
                      <td class="card__content__body--company--name">
                        {{ value.id | limitTo(10) }}
                        <span class="copy-id" title="Copiar ID" @click="copyId(value.id)">
                          <ion-icon name="copy-outline"></ion-icon>
                        </span>
                      </td>
                      <td class="card__content__body--value">
                        {{ value.quantity }}
                      </td>
                      <td class="card__content__body--updated">
                        {{ value.updateDate | formatDate }} <span> às {{ value.updateDate | formatHors24 }} </span>
                      </td>
                      <td class="card__content__body--status">
                        <span v-if="value.status === 'DEFAULT'" class="none">
                          Nenhum
                        </span> <span v-if="value.status === 'OPEN'" class="pending">
                          Pendente
                        </span> <span v-if="value.status === 'PROCESSING'" class="in-progress"
                                      :style="{ padding: '4px 21px'}">
                          Em processo
                        </span> <span v-if="value.status === 'PROCESSED'" class="concluded">
                          Processado
                        </span> <span v-if="value.status === 'CLOSED'" class="canceled">
                          Cancelado
                        </span>
                      </td>
                      <td class="card__content__body--actions">
                        <button v-if="value.status === 'PROCESSING'" @click="cancelOrder(value)">
                          <ion-icon name="chevron-forward-outline"></ion-icon>
                        </button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <pagination v-if="cardOrderList.content.length > 150" :total-items="450" :items-per-page="150"
                            :current-page="pageCardOrder"
                            @update:currentPage="changePageCardOrder"/>
              </div>
            </div>

            <!-- EMBOSSING FILE -->
            <div class="col-md-6 card">
              <div class="col-md-12 card__content">
                <div class="card__content__header">
                <span class="card__content__header--title">
                  Embossing Files
                </span>
                </div>
                <div class="card__content__body">
                  <table class="card__content__body--table">
                    <thead>
                    <tr>
                      <th>ID</th>
                      <th>Quantidade</th>
                      <th>Atualizado em</th>
                      <th>Status</th>
                      <th>Ações</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(value, index) in embossingFiles.content">
                      <td class="card__content__body--company--name">
                        {{ value.id | limitTo(10) }}
                        <span class="copy-id" title="Copiar ID" @click="copyId(value.id)">
                          <ion-icon name="copy-outline"></ion-icon>
                        </span>
                      </td>
                      <td class="card__content__body--value">
                        {{ value.cards }}
                      </td>
                      <td class="card__content__body--updated">
                        {{ value.updateDate | formatDate }} <span> às {{ value.updateDate | formatHors24 }} </span>
                      </td>
                      <td class="card__content__body--status">
                        <span v-if="value.status === 'DEFAULT'" class="none">
                          Nenhum
                        </span> <span v-if="value.status === 'OPEN'" class="pending">
                          Pendente
                        </span> <span v-if="value.status === 'PROCESSING'" class="in-progress">
                          Em processo
                        </span> <span v-if="value.status === 'PROCESSED'" class="concluded">
                          Processado
                        </span> <span v-if="value.status === 'CLOSED'" class="canceled">
                          Cancelado
                        </span>
                      </td>
                      <td class="card__content__body--actions">
                        <button v-if="value.status === 'OPEN'" @click="finishOrder(value)">
                          <ion-icon name="chevron-forward-outline"></ion-icon>
                        </button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <pagination v-if="embossingFiles.content.length > 150" :total-items="450" :items-per-page="150"
                            :current-page="pageEmbossing"
                            @update:currentPage="changePageEmbossing"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import pageHeader from "../../components/default/pageHeader.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import modalDefault from "../../components/modals/modalDefault.vue";
import BtnCustom from "../../components/buttons/btnCustom.vue";
import inputText from "../../components/inputs/inputText.vue";
import Pagination from "../../components/tools/pagination.vue";
import {REQUEST_SERVICE, UTIL_SERVICE} from "../../../../requestConfig";
import {
  GET_CARD_ORDER,
  GET_EMBOSSING_FILES,
  CEP_GLOBAL,
  CREATE_CARD_ORDER,
} from "../../../../urlConfig";
import axios from "axios";
import swal from "sweetalert";
import moment from "moment";
import {ALERT_SERVICE} from "../../../../msgAlertService";

export default {
  name: "benefits-dock",
  components: {
    topMenu,
    pageHeader,
    fullLoading,
    BtnCustom,
    modalDefault,
    inputText,
    Pagination,
  },
  data() {
    return {
      loadingBenefits: false,
      cardOrderList: {
        content: []
      },
      embossingFiles: {
        content: []
      },
      cep: '',
      formIsNotValid: false,
      pageEmbossing: 1,
      pageCardOrder: 1,
      dataOrder: {
        quantity: '',
        city: '',
        complement: '',
        countryCode: 'BR',
        neighborhood: '',
        number: '',
        administrativeAreaCode: '',
        street: '',
        postalCode: '',
        orderAddressee: '',
      }
    };
  },
  methods: {
    sortByStatus(list, status) {
      if (!list.length) return [];
      const targetStatus = list.filter((value) => value.status === status);
      const othersStatus = list.filter((value) => value.status !== status);
      const newList = new Set([...targetStatus, ...othersStatus]);
      return Array.from(newList);
    },
    getCardOrderList() {
      this.loadingBenefits = true;
      REQUEST_SERVICE.get(`${GET_CARD_ORDER}`).then((response) => {
        UTIL_SERVICE.console("RESULT GET_CARD_ORDER:", response);
        this.cardOrderList = response.data;
        this.cardOrderList.content = this.sortByStatus(response.data.content, "PROCESSING");
        this.loadingBenefits = false;
      }).catch((reason) => {
        reason.response.data.erros.map((value, index) => {
          swal("Aviso", value.value, "error");
        });
        this.loadingBenefits = false;
      })
    },
    getEmbossingFiles() {
      this.loadingBenefits = true;
      REQUEST_SERVICE.get(`${GET_EMBOSSING_FILES}?p=${this.pageEmbossing}`).then((response) => {
        UTIL_SERVICE.console('RESULT GET_EMBOSSING_FILES:', response);
        this.embossingFiles = response.data;
        this.embossingFiles.content = this.sortByStatus(response.data.content, "OPEN");

        this.loadingBenefits = false;
      }).catch((reason) => {
        reason.response.data.erros.map((value, index) => {
          swal("Aviso", value.value, "error");
        });
        this.loadingBenefits = false;
      })
    },
    createOrder() {
      this.dataOrder.postalCode = this.cep;
      this.formIsNotValid = false;
      Object.entries(this.dataOrder).forEach(([prop, value]) => {
        if (prop !== 'complement' && value === '') {
          this.formIsNotValid = true;
        } else {
        }
      });

      if (this.formIsNotValid) return;

      $('#modalOrder').modal('hide');
      swal({
        title: "Aviso!",
        text: `Confirme os dados do pedido`,
        content: {
          element: "div",
          attributes: {
            innerHTML: `
                <div style="display: flex; flex-direction: column; align-items: flex-start; margin-left: 24px">
                  <p style="margin: 4px 0">Nome do destinatário: <b>${this.dataOrder.orderAddressee}</b></p>
                  <p style="margin: 4px 0">Quantidade de cartões: <b>${this.dataOrder.quantity}</b></p>
                  <p style="margin: 4px 0">CEP: <b>${this.dataOrder.postalCode}</b></p>
                  <p style="margin: 4px 0">Rua: <b>${this.dataOrder.street}</b></p>
                  <p style="margin: 4px 0">Número: <b>${this.dataOrder.number}</b></p>
                  <p style="margin: 4px 0">Bairro: <b>${this.dataOrder.neighborhood}</b></p>
                  <p style="margin: 4px 0">Cidade: <b>${this.dataOrder.city}</b></p>
                  <p style="margin: 4px 0">Estado: <b>${this.dataOrder.administrativeAreaCode}</b></p>
                </div>`,
          }
        },
        buttons: true,
        dangerMode: true
      }).then((value) => {
        if (value) {
          REQUEST_SERVICE.post(CREATE_CARD_ORDER, this.dataOrder).then((response) => {
            swal({
              title: "Sucesso!",
              text: `Copie o ID do pedido`,
              content: {
                element: "div",
                attributes: {
                  innerHTML: `
                      <div>
                        <b>${response.data}</b>
                      </div>`,
                }
              },
            }).then(() => {
              navigator.clipboard.writeText(response.data);
            })
            this.getCardOrderList();
            this.getEmbossingFiles();
          }).catch((reason) => {
            swal("Aviso", value.value, "error");
          })
        }
      })
    },
    changePageCardOrder(page) {
      this.pageCardOrder = page;
      this.getCardOrderList();
    },
    changePageEmbossing(page) {
      this.pageEmbossing = page;
      this.getEmbossingFiles();
    },
    finishOrder(value) {
      swal({
        title: "Aviso!",
        text: `Esta solicitação contém ${value.cards} cartões. Deseja concluir?`,
        buttons: true,
        dangerMode: true
      }).then((val) => {
        if (val) {
          REQUEST_SERVICE.get(`${GET_EMBOSSING_FILES}/${value.id}/generate`).then((response) => {
            swal("Sucesso!", ``, "success");
            this.getCardOrderList();
            this.getEmbossingFiles();
          }).catch((reason) => {
            swal("Aviso", value.value, "error");
          })
        }
      })
    },
    cancelOrder(value) {
      swal({
        title: "Aviso!",
        text: `Essa ação é irreversível, você tem certeza?`,
        buttons: true,
        dangerMode: true
      }).then((val) => {
        if (val) {
          REQUEST_SERVICE.post(`${GET_CARD_ORDER}/abort?cardOrderId=${value.id}`).then((response) => {
            swal("Sucesso!", ``, "success");
            this.getCardOrderList();
            this.getEmbossingFiles();
          }).catch((reason) => {
            swal("Aviso", value.value, "error");
          })
        }
      })
    },
    openModalCreate() {
      $('#modalOrder').modal();
    },
    copyId(value) {
      navigator.clipboard.writeText(value)
    },
    resetData() {
      this.dataOrder = {
        quantity: '',
        city: '',
        complement: '',
        countryCode: 'BR',
        neighborhood: '',
        number: '',
        administrativeAreaCode: '',
        street: '',
        postalCode: '',
        orderAddressee: '',
      }
    },
  },
  watch: {
    cep() {
      if (this.cep.length === 8) {
        axios.get(CEP_GLOBAL + this.cep + '/json')
          .then((response) => {
            this.dataOrder.city = response.data.localidade;
            this.dataOrder.administrativeAreaCode = response.data.uf;
            this.dataOrder.street = response.data.logradouro;
            this.dataOrder.neighborhood = response.data.bairro;
          })
          .catch((reason) => {
          });
      }
    }
  },
  beforeMount() {
    this.getCardOrderList();
    this.getEmbossingFiles();
  },
};
</script>

<style lang="scss" scoped>

.error-message {
  padding-top: 9px;
  margin-bottom: -40px;
  color: var(--light-red);
}

.container-fluid {
  margin-top: 28px;

  .first__row {
    .card {
      margin-bottom: 30px;

      .card__content {
        background: var(--classic-white);
        border-radius: 10px !important;
        height: 455px;
        padding: 20px;
        position: relative;
        border: 2px solid transparent;

        .btnCreate {
          float: inline-end;
          border: none;
          background: #1b59f8;
          color: #fff;
          font-weight: 600;
          padding: 4px 8px;
          border-radius: 4px !important;

          &:hover {
            background: #2f23d6;
          }
        }

        .card__content__header {
          margin-bottom: 12px;

          .card__content__header--title {
            font-size: 16px;
            font-weight: 700;
            color: var(--dark-black);

            .card__content__header--href {
              font-size: 14px;
              font-weight: 500;
              color: var(--high-blue);
              margin-left: 10px;
            }
          }
        }

        .card__content__body {
          height: 82%;
          overflow-y: scroll;
          margin-bottom: 16px;

          .card__content__body--table {
            width: 99%;
            max-width: 99%;
            margin-bottom: 20px;

            thead {
              font-size: 14px;
              color: var(--high-gray);
              line-height: 220%;
              padding-bottom: 5px;
              border-bottom: 1px solid var(--classic-gray);
              position: sticky;
              top: 0;
              background: #fff;
              z-index: 10;

              tr {
                th {
                  font-weight: 500 !important;
                }
              }
            }

            tbody {
              tr {
                border-bottom: 1px solid var(--classic-gray);

                .card__content__body--company--name {
                  width: 28%;
                  color: var(--dark-gray);
                  padding: 20px 0;

                  .copy-id {
                    position: relative;

                    ion-icon {
                      position: absolute;
                      left: 6px;
                      color: #1b59f8;
                      cursor: pointer;
                      translate: .3s;

                      &:active {
                        font-size: 18px;
                      }
                    }
                  }

                  a {
                    display: list-item;
                    width: 140px;
                    white-space: nowrap;
                    overflow: hidden !important;
                    text-overflow: ellipsis;

                    font-size: 14px;
                    font-weight: 500;
                    color: var(--high-blue);
                    align-items: center;

                    ion-icon {
                      font-size: 14px;
                      margin-right: 4px;
                    }
                  }
                }

                .card__content__body--employee--name {
                  width: 40%;
                  color: var(--high-gray);
                  padding: 10.5px 0;
                  font-size: 13px;
                  font-weight: 400;

                  a {
                    display: list-item;
                    width: 220px;
                    white-space: nowrap;
                    overflow: hidden !important;
                    text-overflow: ellipsis;

                    font-size: 14px;
                    font-weight: 500;
                    color: var(--high-blue);
                    //display: flex;
                    align-items: center;

                    ion-icon {
                      font-size: 14px;
                      margin-right: 4px;
                    }
                  }
                }

                .card__content__body--company--name--latest {
                  width: 45%;
                  padding: 20px 0;

                  a {
                    display: list-item;
                    width: 240px;
                    white-space: nowrap;
                    overflow: hidden !important;
                    text-overflow: ellipsis;

                    font-size: 14px;
                    font-weight: 500;
                    color: var(--high-blue);
                    align-items: center;

                    ion-icon {
                      font-size: 14px;
                      margin-right: 4px;
                    }
                  }
                }

                .card__content__body--status {
                  span {
                    border-radius: 4px !important;
                    font-size: 12px;
                    font-weight: 500;
                    padding: 4px 16px;
                  }

                  .done {
                    color: var(--classic-white);
                    background: var(--dark-gray);
                    padding: 4px 16px;
                  }

                  .draw {
                    color: var(--classic-white);
                    background: var(--high-blue);
                    padding: 4px 24px;
                  }

                  .waiting {
                    color: var(--dark-gray);
                    background: var(--light-yellow);
                    padding: 4px 16px;
                  }

                  .paid {
                    background: var(--light-green);
                    color: var(--classic-white);
                    padding: 4px 38.5px;
                  }

                  .canceled {
                    background: var(--light-red);
                    color: var(--classic-white);
                    padding: 4px 22px;
                  }

                  .pending {
                    color: var(--dark-gray);
                    background: var(--light-yellow);
                    padding: 4px 25px;
                  }

                  .in-progress {
                    color: var(--classic-white);
                    background: var(--high-blue);
                    padding: 4px 12.5px;
                  }

                  .concluded {
                    background: var(--light-green);
                    color: var(--classic-white);
                    padding: 4px 25px;
                  }

                  .none {
                    background: var(--dark-gray);
                    color: var(--classic-white);
                    padding: 4px 27px;
                  }
                }

                .card__content__body--status--kyc {
                  .content--status {
                    display: flex;
                    align-items: center;

                    font-size: 14px;
                    font-weight: 400;
                    color: var(--dark-gray);

                    .point {
                      border-radius: 4px !important;
                      font-size: 12px;
                      font-weight: 500;
                      margin-bottom: 10px;
                    }
                  }

                  .content--status--waiting {
                    .point {
                      padding: 4px 32px;
                      color: var(--dark-gray);
                      background: var(--light-yellow);
                    }
                  }

                  .content--status--approved {
                    .point {
                      padding: 4px 25px;
                      color: var(--classic-white);
                      background: var(--light-green);
                    }
                  }

                  .content--status--disapproved {
                    .point {
                      padding: 4px 21.5px;
                      color: var(--classic-white);
                      background: var(--light-red);
                    }
                  }

                  .content--status--manual-waiting {
                    .point {
                      padding: 4px 8px;
                      color: var(--dark-gray);
                      background: var(--high-orange);
                    }
                  }

                  .content--status--unknow {
                    .point {
                      padding: 4px 10.5px;
                      color: var(--classic-white);
                      background: var(--dark-gray);
                    }
                  }
                }

                .card__content__body--value {
                  font-size: 16px;
                  font-weight: 400;
                  color: var(--dark-gray);
                }

                .card__content__body--updated {
                  display: flex;
                  flex-direction: column;
                  margin-top: 11px;

                  font-size: 14px;
                  font-weight: 400;
                  color: var(--dark-gray);

                  span {
                    font-size: 12px;
                    font-weight: 400;
                    color: var(--high-gray);
                  }
                }

                .card__content__body--actions {
                  button {
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    background: var(--background-gray);
                    width: 28px;
                    height: 28px;
                    padding: 0;
                    border: none;
                    border-radius: 4px !important;
                    transition: 0.2s;

                    ion-icon {
                      color: var(--dark-gray);
                      font-size: 18px;
                      transition: 0.2s;
                    }

                    &:hover {
                      background: var(--high-blue);

                      ion-icon {
                        color: var(--classic-white);
                      }
                    }
                  }
                }
              }
            }
          }
        }

        .card__content__body::-webkit-scrollbar {
          width: 4px;
          position: absolute;
        }

        .card__content__body::-webkit-scrollbar-track {
          background-color: #e6e9ec;
          height: 4px;
          border-radius: 6px;
        }

        .card__content__body::-webkit-scrollbar-thumb {
          background: #3a424e;
          border-radius: 6px;
        }

        .card__content__body::-webkit-scrollbar-thumb:hover {
          background: lighten(#3a424e, 5%);
          transition: 0.5s;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/benefits/benefits-dock.vue